"use client";

import styles from "./info-tabs.module.scss";

const EcosystemServicesTab = () => {
  return (
    <div className={styles.tabContent}>
      <h2>Ecosystem Services</h2>
      <p>
        Peatlands cover just <strong>3% of the global land surface</strong>, yet
        they are the Earth’s largest natural terrestrial carbon store — holding
        more carbon than all the world’s forests combined. Their preservation is
        critical for mitigating climate change.
      </p>
      <br />
      <p>
        According to 
        <a href="https://www.annualreviews.org/content/journals/10.1146/annurev-environ-110615-085520">
          &nbsp;Page and Baird (2016)
        </a>, peatlands store more carbon than any other type of vegetation.
      </p>
      <br />
      <p>
        It is estimated that peatlands globally sequester around{" "}
        <strong>0.37 gigatonnes of CO₂ annually</strong>{" "}
        <a href="https://agupubs.onlinelibrary.wiley.com/doi/full/10.1029/2011eo120001">
          Yu et al., 2010
        </a>
        , making them essential in the fight against climate change.
      </p>
    </div>
  );
};

export default EcosystemServicesTab;
